// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

// Lazy-loaded Components
const AudienceGroupingList = lazy(
  () => import('pages/audienceGrouping/audienceGroupList')
);
const AudienceGroupCreate = lazy(
  () => import('pages/audienceGrouping/audienceGroupCreate')
);
const AudienceGroupShow = lazy(
  () => import('pages/audienceGrouping/audienceGroupShow')
);
const AudienceGroupEdit = lazy(
  () => import('pages/audienceGrouping/audienceGroupEdit')
);

const AudienceGroupingRoute = (
  <Route path={routeName.audienceGrouping}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.AUDIENCE_GROUP_VIEW,
            PrivateRouteConst.SELF_AUDIENCE_GROUP_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <AudienceGroupingList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.AUDIENCE_GROUP_CREATE}>
          <Suspense fallback={<Loading />}>
            <AudienceGroupCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.AUDIENCE_GROUP_EDIT,
            PrivateRouteConst.SELF_AUDIENCE_GROUP_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <AudienceGroupEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.AUDIENCE_GROUP_VIEW,
            PrivateRouteConst.SELF_AUDIENCE_GROUP_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <AudienceGroupShow />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default AudienceGroupingRoute;
